var BufferStatusView = require('bufferstatusview');


var ThreadStatusView = BufferStatusView.extend({
    className: BufferStatusView.prototype.className + ' threadHead',
    events: $.extend({}, BufferStatusView.prototype.events, {
        'buttonClick button.close': 'clickClose'
    }),
    clickClose: function (e) {
        this.model.session.clearThreadId();
        return false;
    },
    render: function () {
        BufferStatusView.prototype.render.apply(this, arguments);
        this.members = $('<span class="thread__members">');
        this.title.append(this.members);
        this.renderMembers();
        this.model.members.on('update', this.renderMembers, this);
        return this;
    },
    renderButtons: function () {
        BufferStatusView.prototype.renderButtons.apply(this);
        this.appendButton('close', 'Close');
    },
    renderMembers: function () {
        var parts = this.model.members.map(function (member) {
            return this.formatter.linkUser(member, {
                noData: true,
                className: 'thread__participant'
            });
        }, this);
        this.members.html(this.formatter.listSentence(parts));
        return this;
    },
    renderLabel: function () {
        var label;
        if (this.model.connection.isSlack()) {
            label = this.formatter.linker.makeLinkFromBits('Thread', {
                url: this.model.getSlackUrl(),
                target: '_blank'
            });
        } else {
            label = 'Thread';
        }
        label += ' from ' + this.formatter.linkModel(this.model);
        this.label.html(label);
    }
});


module.exports = ThreadStatusView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/threadstatusview.js
// module id = SiCN
// module chunks = 1